import AxiosClient from "../../../services/axios.services";

class TitlesServices {
  getTitles = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_titulo/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getTitlesById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_titulo/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveTitles = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_titulo/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editTitles = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_titulo/${id}/`, data, {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteTitles = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_titulo/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new TitlesServices();
